import script from "./CardPacksView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPacksView.vue?vue&type=script&setup=true&lang=js"

import "./CardPacksView.vue?vue&type=style&index=0&id=ed2ad82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed2ad82e"]])

export default __exports__